module.exports = __webpack_public_path__ + "6886f9f25873dfec7643dc940cf8c11c.ttf";